import type { LinkField } from '@uncinc/react-drupal-core/types';

import type { Funder } from '.';

export default function fundersWidgetMapper(funders: LinkField[]): Funder[] {
  return funders.map((funder) => ({
    title: funder.title,
    url: funder.alias ?? funder.uri,
  }));
}
